export const BRAND = {
  name: "Elite Home Care",
  byline: "by Hortense",
  fullName: "Elite Home Care by Hortense",
  phone: "(239) 834-4377",
  phoneHref: "tel:+12398344377",
  email: "admin@techhelpswfl.com",
  serviceArea: "Southwest Florida",
  hours: "Available 24/7 • Mon–Sun",
  address: "Naples • Fort Myers • Cape Coral • Bonita Springs",
  social: {
    facebook: "#",
    instagram: "#",
  },
  cta: {
    primary: "Schedule a Free Consultation",
    primaryShort: "Free Consultation",
    callNow: "Call Now",
  },
};

export const NAV_LINKS = [
  { to: "/", label: "Home", testid: "nav-home" },
  { to: "/services", label: "Services", testid: "nav-services" },
  { to: "/about", label: "About", testid: "nav-about" },
  { to: "/blog", label: "Resources", testid: "nav-blog" },
  { to: "/contact", label: "Contact", testid: "nav-contact" },
];

export const SERVICES = [
  {
    slug: "personal-care",
    title: "Personal Care",
    icon: "HeartPulse",
    short: "Bathing, grooming, dressing",
    description:
      "Dignified, respectful assistance with bathing, grooming, dressing, toileting, and mobility — delivered with patience and professionalism.",
  },
  {
    slug: "companion-care",
    title: "Companion Care",
    icon: "Users",
    short: "Friendly company & conversation",
    description:
      "Warm conversation, shared hobbies, light errands, and meaningful company that ease loneliness and brighten every day.",
  },
  {
    slug: "medication-reminders",
    title: "Medication Reminders",
    icon: "Pill",
    short: "Safe, on-time medication support",
    description:
      "Consistent medication reminders and tracking so loved ones stay on schedule and families gain peace of mind.",
  },
  {
    slug: "meal-preparation",
    title: "Meal Preparation",
    icon: "Utensils",
    short: "Nourishing, home-cooked meals",
    description:
      "Fresh, nutritious meals tailored to dietary needs and personal preferences — cooked with love in your own kitchen.",
  },
  {
    slug: "light-housekeeping",
    title: "Light Housekeeping",
    icon: "Sparkles",
    short: "A tidy, comfortable home",
    description:
      "Laundry, dishes, bed-making, and gentle tidying so the home remains a calm, safe, welcoming place.",
  },
  {
    slug: "transportation",
    title: "Transportation Assistance",
    icon: "Car",
    short: "Appointments, errands, outings",
    description:
      "Reliable rides to doctor visits, pharmacy stops, family gatherings, and errands — with a caring companion along the way.",
  },
  {
    slug: "alzheimers-dementia",
    title: "Alzheimer's & Dementia Care",
    icon: "Brain",
    short: "Specialized, patient, compassionate",
    description:
      "Trained caregivers who understand memory loss — providing structure, safety, and emotional support for clients and families.",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "Hortense's team treated my mother like their own grandmother. After just one week, we could see her smiling again. We finally sleep through the night.",
    name: "Rebecca M.",
    role: "Daughter of client, Naples",
  },
  {
    quote:
      "Professional, warm, and absolutely reliable. They were there every morning, rain or shine, and always went above what was asked.",
    name: "David K.",
    role: "Son of client, Fort Myers",
  },
  {
    quote:
      "The dementia care specialists transformed my father's days. He has purpose again — and our whole family found its footing.",
    name: "Linda P.",
    role: "Daughter of client, Bonita Springs",
  },
];

export const VALUES = [
  {
    title: "Family-first philosophy",
    body: "We care for your loved ones the way we care for our own — with dignity, patience, and unwavering respect.",
  },
  {
    title: "Trusted caregivers",
    body: "Every caregiver is rigorously vetted, trained, background-checked, and matched to your family's unique needs.",
  },
  {
    title: "Concierge-level service",
    body: "Thoughtful communication, consistent scheduling, and a single point of contact you can always reach.",
  },
];

export const IMAGES = {
  hero:
    "https://static.prod-images.emergentagent.com/jobs/e350038a-21ac-4053-b4a9-49e5bc6588fe/images/6f9775759932835ea78dd543230cd6178e99792eb004cd5249b2180a8480c9ed.png",
  founder: "/images/founder-hortense.png",
  testimonialBg:
    "https://static.prod-images.emergentagent.com/jobs/e350038a-21ac-4053-b4a9-49e5bc6588fe/images/f64aad55d90449bea55b973e4c00c55beba61dd3a55314a656d031b3c2e7095c.png",
  service1:
    "https://images.unsplash.com/photo-1773227059334-38d10a9075f2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwyfHxzZW5pb3IlMjBjYXJlJTIwd2FybXxlbnwwfHx8fDE3NzY3NzUyNTZ8MA&ixlib=rb-4.1.0&q=85",
  service2:
    "https://images.pexels.com/photos/8088906/pexels-photo-8088906.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};
